<template>
  <v-app class="split-bg">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card v-if="!successfulReset" class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <v-img
                    :src="settings.branding.logo"
                    alt="Vue Material Admin"
                    max-width="266"
                    max-height="200"
                  />
                </div>
                <v-form>
                  <v-card-text> Please select a new password. </v-card-text>
                  <v-text-field
                    v-model="user.password"
                    append-icon="lock"
                    label="Password"
                    dense
                    type="password"
                  />
                  <v-text-field
                    v-model="user.confirmPassword"
                    append-icon="lock"
                    dense
                    label="Confirm Password"
                    type="password"
                  />
                </v-form>
              </v-card-text>
              <v-spacer />

              <v-btn
                block
                color="primary"
                :disabled="!validPassword"
                @click="reset"
              >
                Reset
              </v-btn>
            </v-card>
            <v-card v-else>
              <div class="layout column align-center">
                <v-img
                  :src="settings.branding.logo"
                  alt="Vue Material Admin"
                  max-width="266"
                  max-height="200"
                />
              </div>
              <v-card-text
                >Your password has been reset. Click
                <router-link :to="{ name: loginPage }">here</router-link>
                to return to the login page</v-card-text
              >
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { User, Associate } from "@/classes";
import request from "@/modules/request";
import settingsMixin from "../../mixins/settingsMixin";

export default {
  name: "ResetPassword",
  props: {
    associate: {
      type: Boolean,
    },
  },
  mixins: [settingsMixin],
  data() {
    return {
      user: {
        password: null,
        confirmPasword: null,
      },
      successfulReset: false,
    };
  },
  mounted() {
    localStorage.removeItem("token");
  },
  computed: {
    validPassword() {
      const { password, confirmPassword } = this.user;
      return password && password === confirmPassword;
    },
    loginPage() {
      return this.associate ? "AssociateLogin" : "UserLogin";
    },
  },
  methods: {
    async reset() {
      const { password, confirmPassword } = this.user;
      const { associate } = this;
      const { token, email } = this.$route.query;
      await request
        .callInternal({
          method: "post",
          route: `/api/resetpassword`,
          data: {
            password,
            confirmPassword,
            token,
            email,
            associate,
          },
        })
        .then(() => {
          this.successfulReset = true;
        })
        .catch((error) => {
          console.log("eror resetting password", error);
        });
    },
  },
};
</script>

<style scoped>
.split-bg {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
